import { z, isoZ } from 'my-zod'

export const historicalRidesCustomerView = z.object({
  businessName: z.string(),
  checkOutDateTime: isoZ.instant().nullable(),
  checkInDateTime: isoZ.instant().nullable(),
  productLine: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  city: z.string().nullable(),
  stateProvince: z.string().nullable(),
  landingHeroImage: z.string().nullable(),
  businessPhone: z.string().nullable(),
  landingSlug: z.string().nullable()
})

export type historicalRidesCustomerView = z.infer<typeof historicalRidesCustomerView>
